import { render } from "./BannerCreate.vue?vue&type=template&id=292f83fb"
import script from "./BannerCreate.vue?vue&type=script&lang=js"
export * from "./BannerCreate.vue?vue&type=script&lang=js"
script.render = render

export default script